define('commons/variables-regex-provider',[],function() {
    var coreRegex = "([a-zA-Z0-9_#]+)";
    return {
        getCustomVarNameRegex: function() {
            return new RegExp(coreRegex, 'g');
        },
        getValidationRegex: function() {
            return new RegExp("{" + coreRegex + "}", 'g');
        }
    }
});
